import { SyncDevice } from '../../../domain/sync/SyncDevice';
import { useSelector } from 'react-redux';
import { getSyncedItemCount } from '../../store/sync/selectors/devices';

const useNumSyncedItems = (peerDeviceUUID: SyncDevice['uuid']) => {
	const syncedItemCounts = useSelector(getSyncedItemCount);
	return syncedItemCounts.get(peerDeviceUUID) || 0;
}

export default useNumSyncedItems;